export default{
    name: 'thisVersion',
    version:'1.0.0'
}


// WEBPACK FOOTER //
// ./src/version.js